import { useEffect, useState } from "react";
import { DeviceMobile, X } from "@phosphor-icons/react";

const LS_KEY = "df_install_hint_dismissed";

function isInstalled() {
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export default function InstallHint() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isInstalled()) return;
    if (localStorage.getItem(LS_KEY) === "1") return;
    setShow(true);
  }, []);

  if (!show) return null;

  const dismiss = () => {
    localStorage.setItem(LS_KEY, "1");
    setShow(false);
  };

  return (
    <div
      data-testid="install-hint"
      className="mb-6 flex items-start gap-3 border border-stone-800 bg-stone-900/40 rounded-sm px-4 py-3"
    >
      <DeviceMobile size={20} weight="bold" className="mt-0.5 shrink-0 text-orange-600" />
      <p className="text-xs sm:text-sm text-stone-400 leading-relaxed">
        <span className="text-stone-200 font-medium">Add The Daily Forge to your Home Screen</span>{" "}
        for the full app experience and daily reminder notifications. On iPhone: tap{" "}
        <span className="text-stone-300">Share → Add to Home Screen</span>. On Android: tap the{" "}
        <span className="text-stone-300">⋮ menu → Add to Home screen</span>.
      </p>
      <button
        data-testid="dismiss-install-hint"
        onClick={dismiss}
        title="Dismiss"
        className="ml-auto shrink-0 text-stone-600 hover:text-stone-300 transition-colors"
      >
        <X size={16} weight="bold" />
      </button>
    </div>
  );
}
